import React from 'react';
import { YfmEditorView } from './YfmEditorView';
import { useYfmEditor } from './useYfmEditor';
/**
 * @deprecated
 * The `YfmEditor` component will be removed soon.
 * Use `useYfmEditor` hook and `YfmEditorView` component instead.
 */
export const YfmEditor = React.forwardRef(function YfmEditor({ className, splitMode, autofocus, initialContent, initialEditorType = 'wysiwyg', initialMenuVisible: initialToolbarVisible = true, initialSplitModeEnabled = false, markupMenubarData: markupToolbarData, wysiwygMenubarData: wysiwygToolbarData, wysiwygExtraExtensions, wysiwygAllowHTML, wysiwygLinkify, wysiwygLinkifyTlds, wysiwygAttrs, wysiwygBreaks = true, extensionOptions, prepareRawMarkup, onMarkupChange, onMenuBarAction: onToolbarAction, onSplitModeEnabledChange, renderPreview, onEditorTypeChange, onMenuVisibleChange: onToolbarVisibleChange, onCancel, onSubmit, onFileUpload, needToSetDimensionsForUploadedImages, settingsVisible, toaster, wysiwygHiddenActionsConfig, markupHiddenActionsConfig, stickyToolbar = true, }, ref) {
    const editor = useYfmEditor({
        splitMode,
        renderPreview,
        initialMarkup: initialContent,
        initialEditorType,
        initialToolbarVisible,
        initialSplitModeEnabled,
        allowHTML: wysiwygAllowHTML,
        linkify: wysiwygLinkify,
        linkifyTlds: wysiwygLinkifyTlds,
        breaks: wysiwygBreaks,
        attrs: wysiwygAttrs,
        extraExtensions: wysiwygExtraExtensions,
        extensionOptions,
        prepareRawMarkup,
        fileUploadHandler: onFileUpload,
        needToSetDimensionsForUploadedImages,
    });
    const viewRef = React.useRef(null);
    const self = React.useMemo(() => {
        const editorRef = editor;
        editorRef.domElem = () => viewRef.current;
        return editor;
    }, [editor]);
    React.useImperativeHandle(ref, () => self, [self]);
    React.useLayoutEffect(() => {
        if (!onSplitModeEnabledChange)
            return;
        const cb = ({ splitModeEnabled }) => {
            onSplitModeEnabledChange(splitModeEnabled);
        };
        self.on('change-split-mode-enabled', cb);
        return () => {
            self.off('change-split-mode-enabled', cb);
        };
    });
    React.useLayoutEffect(() => {
        if (!onEditorTypeChange)
            return;
        const cb = ({ type }) => {
            onEditorTypeChange(type);
        };
        self.on('change-editor-type', cb);
        return () => {
            self.off('change-editor-type', cb);
        };
    }, [onEditorTypeChange, self]);
    React.useLayoutEffect(() => {
        if (!onMarkupChange)
            return;
        const cb = () => {
            onMarkupChange(self, self.currentType);
        };
        self.on('change', cb);
        return () => {
            self.off('change', cb);
        };
    }, [onMarkupChange, self]);
    React.useLayoutEffect(() => {
        if (!onCancel)
            return;
        const cb = () => {
            onCancel(self);
        };
        self.on('cancel', cb);
        return () => {
            self.off('cancel', cb);
        };
    }, [onCancel, self]);
    React.useLayoutEffect(() => {
        if (!onSubmit)
            return;
        const cb = () => {
            onSubmit(self);
        };
        self.on('submit', cb);
        return () => {
            self.off('submit', cb);
        };
    }, [onSubmit, self]);
    React.useLayoutEffect(() => {
        if (!onToolbarAction)
            return;
        const cb = ({ id, editorType }) => {
            onToolbarAction({ action: id, editorType });
        };
        self.on('toolbar-action', cb);
        return () => {
            self.off('toolbar-action', cb);
        };
    }, [onToolbarAction, self]);
    React.useLayoutEffect(() => {
        if (!onToolbarVisibleChange)
            return;
        const cb = ({ visible }) => {
            onToolbarVisibleChange(visible);
        };
        self.on('change-toolbar-visibility', cb);
        return () => {
            self.off('change-toolbar-visibility', cb);
        };
    }, [onToolbarVisibleChange, self]);
    return (React.createElement(YfmEditorView, { markupHiddenActionsConfig: markupHiddenActionsConfig, wysiwygHiddenActionsConfig: wysiwygHiddenActionsConfig, ref: viewRef, editor: editor, autofocus: autofocus, settingsVisible: settingsVisible, markupToolbarConfig: markupToolbarData, wysiwygToolbarConfig: wysiwygToolbarData, className: className, toaster: toaster, stickyToolbar: stickyToolbar }));
});
